<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 class="cont_page">
          <v-flex xs12 sm7 md7 class="img-letra animated fadeInUp dura-1"> 
            <img :src="require('@/assets/unidad1/slide-1/'+nameImg+'.png')" alt="">
          </v-flex>
          <v-flex xs12 sm7 md7 class="cont-letras-textos animated fadeInUp dura-1"> 
            <p v-if="onboarding == 0">{{letrasA.textos[valueLetra]}}</p>
            <p v-if="onboarding == 1">{{letrasB.textos[valueLetra]}}</p>
            <p v-if="onboarding == 2">{{letrasC.textos[valueLetra]}}</p>
          </v-flex>

          <audio-player ref="audioPlayer" :audios="letrasA.audio">
          </audio-player> 
          <audio-player  ref="audioPlayerB" :audios="letrasB.audio">
          </audio-player>
          <audio-player  ref="audioPlayerC" :audios="letrasC.audio">
          </audio-player> 

          <v-flex class="cont-img animated fadeInUp dura-2" md10 xs12>
              <v-card color="transparent" flat tile>

                  <v-window v-model="onboarding">
                    <v-window-item  v-for="n in length" :key="`card-${n}`">
                      <v-card class="cont_text-slider" color="transparent" flat>
                        <div class="cont-letras" v-if="onboarding == 0">
                          <button class="hvr-scale letra-button" v-for="i in 9" :key="'lt'+i" 
                          @click="mostrarLetraA(i)" :class="{'active':btnVistoA[i-1]}">
                              <h3 class="t-blue">{{letrasA.letras[i-1]}}</h3>
                          </button>
                        </div>
                        <div class="cont-letras" v-if="onboarding == 1">
                          <button class="hvr-scale letra-button" v-for="b in 9" :key="'lt'+b" 
                          @click="mostrarLetraB(b)" :class="{'active':btnVistoB[b-1]}">
                              <h3 class="t-blue">{{letrasB.letras[b-1]}}</h3>
                          </button>
                        </div>
                        <div class="cont-letras" v-if="onboarding == 2">
                          <button class="hvr-scale letra-button" v-for="c in 8" :key="'lt'+c" 
                          @click="mostrarLetraC(c)" :class="{'active':btnVistoC[c-1]}">
                              <h3 class="t-blue">{{letrasC.letras[c-1]}}</h3>
                          </button>
                        </div>
                      </v-card>
                    </v-window-item>
                  </v-window>

                  <v-card-actions class="cont_buttons-slider">
                    <v-item-group light v-model="onboarding" class="text-center">
                      <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                        <v-btn dark :color="active ? '#3C9043' : '#D3D2D2'" icon small class="item-button" :input-value="active" @click="toggle">
                          <v-icon>mdi-record</v-icon>
                        </v-btn>
                      </v-item>
                    </v-item-group>
                  </v-card-actions>

              </v-card>
          </v-flex>
        </v-layout>
        
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      currentText: 0,
      dialogos: [
        'Clique nas letras para escutar como se pronunciam.'        
      ],
      textoSlide:[
        'Entenda e use expressões familiares e cotidianas, bem como declarações muito simples para atender necessidades específicas',
        'Apresente-se ou apresente alguém, faça perguntas a uma pessoa sobre onde você mora, seus relacionamentos, pertences etc. e pode respondê-las.',
        'Comunique-se facilmente, se o interlocutor fala lenta e claramente e está disposto a colaborar para estabelecer uma comunicação básica.'
      ],
      letrasA:{
        letras:['A','B','C','D','E','F','G','H','I'],
        textos:[
          'a (Amazônia)',
          'bê (Brasil)',
          'cê (Carnaval)',
          'dê (Dólar)',
          'é/ê (Escola)',
          'éfi (Futebol)',
          'yê (Gelo)',
          'agá (Homem)',
          'I (Ipanema)',
        ],
        audio:['ABCD/A','ABCD/B','ABCD/C','ABCD/D','ABCD/E','ABCD/F','ABCD/G','ABCD/H','ABCD/I']
      },
      letrasB:{
        letras:['J','K','L','M','N','O','P','Q','R'],
        textos:[
          'yota (Jogo)',
          'ca (Kátia)',
          'éli (Liberdade)',
          'émi (Maracanã)',
          'éni (Natal)',
          'o (Ontem)',
          'pê (Pelé)',
          'quê (Quilômetro)',
          'éji (Rio)',
        ],
        audio:['ABCD/J','ABCD/K','ABCD/L','ABCD/M','ABCD/N','ABCD/O','ABCD/P','ABCD/Q','ABCD/R']
      },
      letrasC:{
        letras:['S','T','U','V','W','X','Y','Z'],
        textos:['ési (Samba)',
          'tê (Tropical)',
          'u (Universo)',
          'vê (Verde)',
          'dábliu (Web)',
          'shis (Xícara)',
          'ípsilon (Yolanda)',
          'zê (Zero)'
          ],
        audio:['ABCD/S','ABCD/T','ABCD/U','ABCD/V','ABCD/W','ABCD/X','ABCD/Y','ABCD/Z']
      },
      length: 3,
      onboarding: 0,
      nameImg:'A',
      valueLetra:0,
      btnVistoA:Array(9).fill(false),
      btnVistoB:Array(9).fill(false),
      btnVistoC:Array(8).fill(false),
      active:false,
      vistos:Array(3).fill(false)
    }
  },
  methods: {
    mostrarLetraA(val){
      this.nameImg = this.letrasA.letras[val-1]
      this.valueLetra = val-1
      this.$set(this.btnVistoA,val-1,true)
      var todosVistosA = this.btnVistoA.every(el => {return el})
      if(todosVistosA) {
        this.$set(this.vistos,0,true)
      }
      this.$refs.audioPlayer.playAudio(val-1)
    },
    mostrarLetraB(val){
      this.nameImg = this.letrasB.letras[val-1]
      this.valueLetra = val-1
      this.$set(this.btnVistoB,val-1,true)
      var todosVistosB = this.btnVistoB.every(el => {return el})
      if(todosVistosB) {
        this.$set(this.vistos,1,true)
      }
      this.$refs.audioPlayerB.playAudio(val-1)
    },
    mostrarLetraC(val){
      this.nameImg = this.letrasC.letras[val-1]
      this.valueLetra = val-1
      this.$set(this.btnVistoC,val-1,true)
      var todosVistosC = this.btnVistoC.every(el => {return el})
      if(todosVistosC) {
        this.$set(this.vistos,2,true)
      }
      this.$refs.audioPlayerC.playAudio(val-1)
    }
  }
}
</script>
<style lang="scss" scoped>

@import '../../sass/globals';
.cont_text-slider{
  height: auto;
  p{
    font-family: Poppins-Regular;
    font-size: 12px;
  }
}
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 20px;
    height: 20px;
  }
}
.cont-letras{
  .letra-button{
    border: solid $ibra-dark-blue;
    width: 53px;
    height: 53px;
    margin: 8px;
    border-radius: 10px;
    .t-blue{
      color: $ibra-dark-blue;
      font-family:Poppins-Regular;
      font-size: 35px;
      margin: 0;
      padding: 0;
      line-height: 0;
    }
  }
}
.active{
  background: $ibra-dark-blue;
  .t-blue{
    color: white!important;
  }
}

.t-first{
   font-family:Poppins-BoldItalic;
   font-size: 20px;
}

.img-letra{
  img{
    width: 200px;
    @media screen and (min-width: 900px) {
      width: 400px;
    }
  }
}
.cont-letras-textos{
    p{
      margin: 0;
      padding: 0;
      font-family:Poppins-Bold;
      font-size: 13px;
      padding: 5px;
    }
}

</style>
